import Text from "../../../../../components/Text"
import { Spacer } from "../../../../../components/spacer/Spacer"
import { theme } from "../../../../../styles/stitches.config"
import { ContractDisplayResults } from "../../acquisitionForm/sections/contractTypeSection/ContractSelection.styled"
import { ContractSelectionBtn } from "../../acquisitionForm/sections/contractTypeSection/ContractSelectionBtn"
import { RadioGroupRoot } from "../../acquisitionForm/sections/contractTypeSection/ContractSelectionButtons.styled"
import { ProductDetailsBottom } from "../../acquisitionForm/sections/contractTypeSection/ProductDetailsBottom"
import { ProductsPriceDetail } from "../../acquisitionForm/sections/contractTypeSection/ProductsPriceDetail"
import { Product, productSchema } from "../../acquisitionForm/form/useAcquisitionFormSchema"
import { Div } from "../../../../../components/div/Div"
import { isNotNil } from "@nano-portal/shared"

type Props = {
  value: Product
  onChange?: (selected: Product) => void

  productionDataTariff: boolean
  onProductionDataTariffChange: (value: boolean) => void
}

export function ContractTypeSelection(props: Props) {
  const { value, onChange, productionDataTariff, onProductionDataTariffChange } = props

  function handleValueChange(productValue: string) {
    if (!onChange) {
      return
    }

    const selectedProduct = productSchema.parse(productValue)
    onChange(selectedProduct)
  }

  return (
    <>
      <Text type="headerH2" css={{ width: "100%", textAlign: "center", display: "block", fontSize: "20px" }}>
        Vyberte si typ smlouvy
      </Text>
      <Spacer size={theme.space.s9} />
      <RadioGroupRoot onValueChange={handleValueChange} value={value}>
        <ContractSelectionBtn
          text={
            <Text type="headerH3">
              Chci
              <br />
              <Text type="headerH3" color="secondary">
                odebírat
              </Text>
            </Text>
          }
          icon="Consumption"
          value="consumption"
          selected={value === "consumption"}
        />
        <Spacer size={theme.space.s3_5} />
        <ContractSelectionBtn
          text={
            <Text type="headerH3">
              Chci
              <br />
              <Text type="headerH3" color="secondary">
                prodávat
              </Text>
            </Text>
          }
          icon="Production"
          value="production"
          selected={value === "production"}
        />
        <Spacer size={theme.space.s3_5} />
        <ContractSelectionBtn
          text={
            <Text type="headerH3">
              Chci
              <br />
              <Text type="headerH3" color="secondary">
                odebírat i prodávat
              </Text>
            </Text>
          }
          icon="ProductionAndConsumption"
          value="productionAndConsumption"
          selected={value === "productionAndConsumption"}
        />
      </RadioGroupRoot>

      <Spacer size={theme.space.s8} />

      {isNotNil(value) && (
        <ContractDisplayResults align="center" wrap="wrap">
          <Div css={{ flex: 1 }}>
            <Text type="headerH2" css={{ margin: 0, textAlign: "center", fontSize: "20px", lineHeight: "30px" }}>
              Vaše cena
            </Text>
            <Spacer size={theme.space.s5_5} />
            <ProductsPriceDetail selectedProduct={value} productionDataTariff={productionDataTariff} />
          </Div>
          <ProductDetailsBottom
            selectedProduct={value}
            productionDataTariff={productionDataTariff}
            handleProductionDataTariffChange={onProductionDataTariffChange}
          />
        </ContractDisplayResults>
      )}
    </>
  )
}
